import { CSSProperties } from 'react';

// This style should be used for all containers that wrap absolute positioned background images to make SE robots able to search through the web-page
// `relative` classname is not enough because google web cache trims CSS and JS, that makes absolute images overlap all the web-page and prevents links and other content from being clickable
export const containerWithBackgroundImageStyle: CSSProperties = {
  position: 'relative'
};
